module.exports = __webpack_public_path__ + "img/bitmart.aea3975c.svg";